// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import QuoteRequestPage from "../pages/QuoteRequest/QuoteRequest";
const __wvcRoutePaths = ["/QuoteRequestPage", "/offertforfragan"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["aboutuspage", "badrum", "badrumsrenovering-arvika", "badrumsrenovering-karlstad", "bathroompage", "bathroomrenovationarvikapage", "bathroomrenovationkarlstadpage", "brandspage", "contactuspage", "hem", "homepage", "inspiration", "inspirationpage", "kontakt-oss", "offertforfragan", "om-oss", "post", "quoterequestpage", "varumarken"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<QuoteRequestPage />} />
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<QuoteRequestPage />} />
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
